import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import TextInput from '@wix/da-ds/pkg/formControls/dsPresets/TextInput';
import Send from '@wix/da-ds/pkg/Icons/24x24/Send';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import LoadingIndicator from '../LoadingIndicator';
import isValidEmailAddress from '../utils/isValidEmailAddress';
import s from './VerificationEmailInput.scss';
const VerificationEmailInput = ({ className, isEmailChangeInProgress, isResendInProgress, updateFailed, changeEmail })=>{
    const { t } = useTranslation();
    const [currentValue, setCurrentValue] = useState('');
    const [canSubmit, setCanSubmit] = useState(false);
    const [validationFailed, setValidationFailed] = useState(false);
    const validationErrorTimeout = useRef(null);
    const isChangeInProgress = isEmailChangeInProgress || isResendInProgress;
    const hasErrors = updateFailed || validationFailed;
    const doSubmit = ()=>{
        if (canSubmit && !isChangeInProgress) {
            changeEmail(currentValue);
        }
    };
    const handleInputChange = (ev)=>{
        const value = ev.target.value;
        const isValid = isValidEmailAddress(value);
        setCurrentValue(value);
        isValid !== canSubmit && setCanSubmit(isValid);
        // Avoid showing errors for 2 seconds until the user stops typing
        if (validationErrorTimeout.current) {
            window.clearTimeout(validationErrorTimeout.current);
            validationErrorTimeout.current = null;
        }
        if (isValid || !value) {
            setValidationFailed(false);
        } else {
            validationErrorTimeout.current = window.setTimeout(()=>setValidationFailed(true), 2000);
        }
    };
    const handleInputKeyPress = (ev)=>{
        if (!ev.defaultPrevented && ev.key === 'Enter') {
            doSubmit();
        }
    };
    const suffix = /*#__PURE__*/ React.createElement(PlainButtonOrLink, {
        onClick: doSubmit,
        className: cn(s['submit-btn'], !canSubmit && s['disabled'])
    }, isEmailChangeInProgress ? /*#__PURE__*/ React.createElement(LoadingIndicator, {
        view: "spinner",
        className: s['loader']
    }) : /*#__PURE__*/ React.createElement(Send, null));
    return /*#__PURE__*/ React.createElement(TextInput, {
        id: "verification-email-input",
        label: t('verification.emailInput.placeholder'),
        placeholder: t('verification.emailInput.placeholder'),
        value: currentValue,
        postfix: suffix,
        validationResult: hasErrors ? 'error' : undefined,
        details: hasErrors && t('verification.emailInput.error'),
        className: cn(className, canSubmit && s['valid']),
        onChange: handleInputChange,
        onKeyPress: handleInputKeyPress,
        isLabelHidden: true
    });
};
export default VerificationEmailInput;
